import React from 'react';
import { Virtuoso } from 'react-virtuoso';

import { Spinner, Avatar, SearchTextField, CloseBtn, CheckboxField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { userFullName, lang, rgba, scssVariables, getSelectLabel } from 'src/helpers';

import model from './model';
import constants from 'src/constants';

class ContactsList extends BaseComponent {
  componentDidMount() {
    model.loadSelected(this.props.data || [], (error, data) => {
      this.setState({ selected: data || [] });
    });
    model.handleChangeSearch('');
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let loading = model.refreshing();
    const { data, onClose, onChange, type, style, title } = this.props;

    let items = [];

    if (searchQuery) {
      items = model.items();
    } else {
      items = [...(this.state.selected || [])];
      model.items().forEach((item) => {
        let index = items.findIndex((i) => i.id === item.id);
        if (items[index]) {
          items[index] = item;
        } else {
          items.push(item);
        }
      });
    }

    return (
      <div className='mc-flex-20-col' style={style}>
        <div className={'mc-flex-30-col mc-p10'}>
          {type !== 'forward' && (
            <div className={'mc-flex'}>
              <div className={'mc-value-620 mc-grow'}>{lang.t(title)}</div>
              <CloseBtn onClose={onClose} style={{}} />
            </div>
          )}
          <SearchTextField
            template={'2'}
            placeholder={'Search'}
            onChange={model.handleChangeSearch}
            value={searchQuery}
          />
        </div>
        <div className={'mc-grow'}>
          {items &&
            (model.getApiState('accounts').loading ? (
              <Spinner />
            ) : (
              <Virtuoso
                data={items}
                components={{
                  Footer: () => (
                    <div style={{ textAlign: 'center' }}>
                      {noResults && !searchQuery && <div>{lang.t('No results yet')}</div>}
                      {noResults && searchQuery && <div>{lang.t('Nothing found')}</div>}
                      {loading && <Spinner />}
                    </div>
                  )
                }}
                endReached={() => {
                  if (model.hasMore() && !model.refreshing()) model.loadMore();
                }}
                itemContent={(index, item) => {
                  return (
                    <label
                      className={'mc-flex mc-p15 mc-b2 mc-mb10 mc-pointer'}
                      style={{
                        borderColor:
                          data?.indexOf(item.id) > -1
                            ? rgba(scssVariables['colors-mc-primary'], 0.5)
                            : 'white'
                      }}
                    >
                      <Avatar
                        width={50}
                        height={50}
                        text={userFullName(item)}
                        onlineState={item.partnerOnline > 0 ? 'online' : ''}
                        image={(item.avatar || '').replace('/full_', '/350_')}
                      />
                      <div className={'mc-flex-5-col mc-grow'}>
                        <div className={'mc-value-618'}>
                          {(item.isDoctor ? 'Dr. ' : '') + userFullName(item)}
                        </div>
                        <div className={'mc-label-416'}>
                          {getSelectLabel(constants.general.specialist, item.specialist)}
                        </div>
                      </div>
                      <CheckboxField
                        className={'round'}
                        checked={data.indexOf(item.id) > -1}
                        onChange={() => {
                          let newData = data.concat([]) || [];
                          const index = newData.indexOf(item.id);
                          if (index > -1) newData.splice(index, 1);
                          else newData.push(item.id);
                          onChange(newData);
                          if (searchQuery) {
                            if (index > -1)
                              this.setState({
                                selected: this.state.selected.filter((i) => i.id !== item.id)
                              });
                            else this.setState({ selected: [...this.state.selected, item] });
                          }
                        }}
                      />
                    </label>
                  );
                }}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default ContactsList;
